import React from 'react';
import { TagIcon } from '@heroicons/react/24/outline';

const ResourceTypes: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Resource Types</h1>
      <p className="section-description">
        Define and manage different types of resources with customizable settings and properties.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <TagIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Type Management</h3>
              <p className="feature-description">
                Handle resource types with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit resource types</li>
                <li>Set type key and label</li>
                <li>Toggle type activation</li>
                <li>Delete individual types</li>
                <li>Bulk delete multiple types</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <TagIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Type Configuration</h3>
              <p className="feature-description">
                Customize resource type settings:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Display order management</li>
                <li>File upload settings</li>
                <li>Preview settings</li>
                <li>Category settings</li>
                <li>ISBN settings</li>
                <li>Client name settings</li>
                <li>Steps settings</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <TagIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Type List</h3>
              <p className="feature-description">
                View and manage types in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Type key (searchable, sortable)</li>
                <li>Type label (searchable, sortable)</li>
                <li>Active status (sortable)</li>
                <li>Display order (sortable)</li>
                <li>Creation date (sortable)</li>
                <li>Last update date (sortable)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <TagIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Settings Management</h3>
              <p className="feature-description">
                Configure type-specific features:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Enable/disable file uploads</li>
                <li>Enable/disable previews</li>
                <li>Enable/disable categories</li>
                <li>Enable/disable ISBN field</li>
                <li>Enable/disable client name field</li>
                <li>Enable/disable steps field</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Use clear, descriptive type labels</li>
            <li>Choose meaningful type keys</li>
            <li>Set appropriate display order</li>
            <li>Enable only necessary settings</li>
            <li>Regularly review type usage</li>
            <li>Keep type documentation updated</li>
            <li>Test type settings thoroughly</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ResourceTypes; 